var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    { attrs: { viewBox: "0 0 350 300", xmlns: "http://www.w3.org/2000/svg" } },
    [
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "Car-Outside-Path-1",
                x1: "50%",
                y1: "0%",
                x2: "50%",
                y2: "59.6%",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#A6CE91", offset: "0%" } }),
              _c("stop", {
                attrs: { "stop-color": "#83B96A", offset: "100%" },
              }),
              _c("stop", {
                attrs: { "stop-color": "#83B96A", offset: "100%" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "Car-Outside-Path-2",
                x1: "36.4%",
                y1: "0%",
                x2: "58.9%",
                y2: "100%",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#00A0DF", offset: "0%" } }),
              _c("stop", {
                attrs: { "stop-color": "#0079E7", offset: "100%" },
              }),
            ],
            1
          ),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "Car-Outside-Path-3",
                x1: "8.4%",
                y1: "39.4%",
                x2: "106.8%",
                y2: "74.6%",
              },
            },
            [
              _c("stop", { attrs: { "stop-color": "#434343", offset: "0%" } }),
              _c("stop", {
                attrs: { "stop-color": "#292929", offset: "100%" },
              }),
              _c("stop", {
                attrs: { "stop-color": "#292929", offset: "100%" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", {
          attrs: {
            d: "M5 0h346v300H5a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4Z",
            fill: "#FFF",
          },
        }),
        _c("path", {
          attrs: {
            d:
              "M0 197c19.3 16 53.2 19 101.6 8.8 72.6-15.3 91.8 4 149.9-5.6 38.7-6.4 71.5 12.1 98.5 55.7H0v-59Z",
            fill: "url(#Car-Outside-Path-1)",
            transform: "translate(1 44)",
          },
        }),
        _c("path", { attrs: { fill: "#FFF", d: "M1 107h217.3v150.8H1z" } }),
        _c("path", { attrs: { fill: "#DDD", d: "M1 258h203.1V122H1z" } }),
        _c("path", { attrs: { d: "M217.9 258.2v-148 148Z", fill: "#FFF" } }),
        _c("path", {
          attrs: {
            stroke: "#7E7E7E",
            "stroke-width": ".9",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            d: "m217.9 258.2.6-153.7",
          },
        }),
        _c("path", {
          attrs: { fill: "#ECECEC", d: "M203.2 105H13.5l-1-14.2h191.6z" },
        }),
        _c("path", {
          attrs: { d: "M1 44h208.2l18.9 54.1H1V44", fill: "#DDD" },
        }),
        _c("path", {
          attrs: {
            d: "M1 44h208.2l18.9 54.1H1",
            stroke: "#7E7E7E",
            "stroke-width": ".9",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
          },
        }),
        _c("g", [
          _c("path", {
            attrs: {
              stroke: "#7E7E7E",
              "stroke-width": ".9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M273 253.2v-47.9M235.6 253.2v-31",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M266.9 233.7a21.8 21.8 0 0 1-21.3-27l5.7-22.7c.8-2.9 2-5.5 3.8-7.9l.3-.3a22 22 0 0 1 35 0l.2.3c1.8 2.4 3.1 5 3.8 7.9l5.8 22.7c3.4 13.7-7 27-21.3 27h-12Z",
              fill: "#A6CE91",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M266.9 233.7a21.8 21.8 0 0 1-21.3-27h0l5.7-22.7c.8-2.9 2-5.5 3.8-7.9l.3-.3a22 22 0 0 1 35 0l.2.3c1.8 2.4 3.1 5 3.8 7.9l5.8 22.7h0c3.4 13.7-7 27-21.3 27h-12Z",
              stroke: "#7E7E7E",
              "stroke-width": ".9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M232.6 240.8c-9.3 0-16-8.7-13.8-17.6l3.7-14.9c.5-1.8 1.3-3.6 2.5-5.1l.1-.2c5.7-7.5 17-7.5 22.8 0l.2.2c1.1 1.5 2 3.3 2.4 5.1l3.8 14.9c2.2 9-4.6 17.6-13.9 17.6h-7.8Z",
              fill: "#7AB25D",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M232.6 240.8c-9.3 0-16-8.7-13.8-17.6h0l3.7-14.9c.5-1.8 1.3-3.6 2.5-5.1l.1-.2c5.7-7.5 17-7.5 22.8 0l.2.2c1.1 1.5 2 3.3 2.4 5.1l3.8 14.9h0c2.2 9-4.6 17.6-13.9 17.6h-7.8Z",
              stroke: "#7E7E7E",
              "stroke-width": ".9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ]),
        _c("g", [
          _c("path", {
            attrs: {
              d:
                "M6.9 0A6.9 6.9 0 0 0 0 6.9v55.6c0 3.8 3.1 7 6.9 7h15.5c3.8 0 6.9-3.2 6.9-7V7c0-3.8-3-6.9-6.9-6.9H7Z",
              fill: "url(#Car-Outside-Path-2)",
              transform: "translate(18.7 158.6)",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M31.3 167.9a2.1 2.1 0 1 0 4.2 0 2.1 2.1 0 0 0-4.2 0M31.3 174.7a2.1 2.1 0 1 0 4.2 0 2.1 2.1 0 0 0-4.2 0M27.4 187.1a6 6 0 1 0 12 0 6 6 0 0 0-12 0",
              fill: "#FFF",
            },
          }),
          _c("path", {
            attrs: {
              d: "M34 186.7s-4.6 7 16 7c20 0 25.4 18 25.4 18",
              stroke: "#7E7E7E",
              "stroke-width": ".9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("path", {
            attrs: {
              d: "M35.5 187a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0",
              fill: "#7E7E7E",
            },
          }),
          _c("path", {
            attrs: {
              fill: "#F6B140",
              d: "m38 209.9-6.7 11.7 1.6-9.2-4 .7 5.7-13.6-.6 11z",
            },
          }),
          _c("path", {
            attrs: {
              stroke: "#FFF",
              fill: "#F6B140",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "m38 209.9-6.7 11.7 1.6-9.2-4 .7 5.7-13.6-.6 11z",
            },
          }),
        ]),
        _c("g", [
          _c("g", { attrs: { fill: "#292929" } }, [
            _c("path", {
              attrs: {
                d:
                  "M171.8 261.4h6.7c3.2 0 5.9-2.6 5.9-5.8V240c0-3.2-2.7-5.8-5.9-5.8h-6.7a5.9 5.9 0 0 0-5.8 5.8v15.7c0 3.2 2.6 5.8 5.8 5.8M72.5 261.4h6.7c3.2 0 5.8-2.6 5.8-5.8V240c0-3.2-2.6-5.8-5.8-5.8h-6.7a5.9 5.9 0 0 0-5.9 5.8v15.7c0 3.2 2.7 5.8 5.9 5.8",
              },
            }),
          ]),
          _c("path", {
            attrs: {
              d:
                "M52.6 0C33.8 0 29.3 1.8 29.3 1.8c-3.8 0-12 14.6-14.4 19a3 3 0 0 1-1.5-1.3c0-.8-.6-1.5-1.5-1.7l-5.3-1c-.3 0-.6.1-.7.3-.7.9-1.3 2.2-1.6 3-.2.3-.2.7-.1 1 .2.6.6.8 1.3.9l5.7 1c.7.1 1.4-.1 1.7-.6l.8 1-.4.8c-.7 2-2.3 3.7-4.2 4.5H9C8 29.4 7 30 6.2 31c-1.7 2-4.3 5.5-5.2 10-.7 4-.6 8-.5 10.7.2 1.8-.5 3.5-.5 5.3 0 .2.2 11.4 3.6 14.7 0 0 .4 1.7 4.6 1.7H109c4.2 0 4.7-1.7 4.7-1.7 3.3-3.3 3.5-14.4 3.5-14.7 0-1.8-.6-3.5-.5-5.3.2-2.7.2-6.7-.5-10.6-.9-4.6-3.4-8.2-5.1-10.1a8.1 8.1 0 0 0-2.9-2.1c-2-1-3.5-2.6-4.3-4.6l-.3-.8.8-1c.3.5 1 .7 1.7.6l5.7-1c.7-.1 1.1-.3 1.3-.9v-1c-.4-.8-1-2.1-1.7-3a.7.7 0 0 0-.7-.2l-5.3 1c-1 0-1.6.8-1.5 1.6-.3.4-.8 1-1.5 1.3-2.4-4.4-10.7-19-14.4-19C88 1.8 77.4 0 58.6 0h-6Z",
              transform: "translate(67.4 175.4)",
              fill: "url(#Car-Outside-Path-3)",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M67.4 232.3c0-1.8.6-3.5.5-5.3-.2-2.7-.2-6.7.5-10.6.9-4.5 3.4-8.1 5.1-10.1a8.1 8.1 0 0 1 3-2.1c1.9-1 3.4-2.6 4.2-4.6l.3-.9-.7-.9c-.4.5-1 .7-1.7.6l-5.7-1c-.8-.1-1.2-.3-1.3-.9-.2-.3-.1-.7 0-1 .3-.8 1-2.1 1.6-3 .2-.2.5-.3.7-.2l5.4 1c.9 0 1.6.8 1.5 1.6.3.4.8 1 1.4 1.2 2.4-4.3 10.7-18.9 14.5-18.9 0 0 4.5-1.8 23.3-1.8h6c18.8 0 29.3 1.8 29.3 1.8 3.8 0 12 14.6 14.4 19 .7-.2 1.3-.9 1.5-1.3 0-.8.6-1.5 1.6-1.7l5.3-1c.3 0 .5.1.7.3.7.9 1.3 2.2 1.6 3 .1.3.2.7 0 1 0 .6-.5.8-1.2.9l-5.8 1c-.7.1-1.3-.1-1.6-.6l-.8 1 .3.8a8.3 8.3 0 0 0 4.3 4.6c1.1.5 2 1.2 2.8 2 1.7 2 4.3 5.7 5.2 10.2.7 3.9.7 7.9.5 10.6-.2 1.8.5 3.5.5 5.3 0 .3-.2 11.4-3.5 14.7 0 0-.5 1.7-4.7 1.7H75.6c-4.2 0-4.7-1.7-4.7-1.7-3.3-3.3-3.5-14.5-3.5-14.7Z",
              stroke: "#7E7E7E",
              "stroke-width": ".9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "m130.9 221.3 2-4 .3-.2 22.5-2.4c.2 0 .4.2.4.4l-1 3.9-.4.2-23.5 2.6a.3.3 0 0 1-.3-.5M122.3 221.3l-2-4-.3-.2-22.5-2.4c-.2 0-.4.2-.3.4l1 3.9c0 .1.1.2.3.2l23.5 2.6c.2 0 .4-.3.3-.5M179.2 238l-.3 3.3c-.2 1-1 1.9-2.2 2l-2.8.5c-1.4.2-2.8 0-4-.6-1.5-.7-3.3-2-3.8-4 0 0-.7-1.5.9-1.7l10.7-1c.8 0 1.5.6 1.5 1.5M74 238c0 1 0 2.2.3 3.3.2 1 1 1.9 2.1 2l2.9.5c1.3.2 2.7 0 4-.6 1.5-.7 3.2-2 3.7-4 0 0 .8-1.5-.8-1.7l-10.7-1c-.8 0-1.5.6-1.5 1.5",
              fill: "#A6A8AB",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M177 211.1c-2.1 0-9-.8-17 2.1-.3.1-.4.2-.4.4v7c0 .2.1.4.4.4 2.1-.1 12.8-.6 19-3.1.1 0 .2-.3.1-.4l-1.7-6.1c0-.2-.3-.3-.5-.3M73 211.1c2.1 0 8.9-.8 17 2.1.2.1.4.2.4.4v7c0 .2-.2.4-.4.4-2.2-.1-12.8-.6-19-3.1-.2 0-.2-.3-.2-.4l1.8-6.1c0-.2.2-.3.4-.3",
              fill: "#7E7E7E",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M158.7 197.8c2.2-.4 3.6-2 3.2-3.5l-2-7.7c-.4-1.5-2.4-3-4.3-3.4a179.7 179.7 0 0 0-59.2 0c-2 .3-3.9 1.9-4.3 3.4l-2 7.7c-.4 1.5 1 3.1 3.2 3.5 21.5 3.6 43.9 3.6 65.4 0Z",
              fill: "#FFF",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M93.3 197.8c21.5 3.6 43.9 3.6 65.4 0 2.2-.4 3.6-2 3.2-3.5l-2-7.7c-.4-1.5-2.4-3-4.3-3.4a179.7 179.7 0 0 0-59.2 0c-2 .3-3.9 1.9-4.3 3.4l-2 7.7c-.4 1.5 1 3.1 3.2 3.5Z",
              stroke: "#7E7E7E",
              "stroke-width": ".9",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M158.7 197.8c2.2-.4 3.6-2 3.2-3.5l-2-7.7c-.4-1.5-2.4-3-4.3-3.4a179.7 179.7 0 0 0-59.2 0c-2 .3-3.9 1.9-4.3 3.4l-2 7.7c-.4 1.5 1 3.1 3.2 3.5 21.5 3.6 43.9 3.6 65.4 0Z",
              fill: "#FFF",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M103.9 199.3c18.2 2 36.8 1.6 54.8-1.5 2.2-.4 3.6-2 3.2-3.5l-2-7.7c-.4-1.5-2.4-3-4.3-3.4a179 179 0 0 0-31.4-2.5",
              fill: "#CCECF9",
            },
          }),
          _c("path", {
            attrs: {
              d:
                "M95.9 244.4h60.6c1.3 0 2-1 1.8-2.1l-2.1-9c-.3-1.2-1.4-2.2-2.6-2.2H98.8c-1.1 0-2.3 1-2.6 2.2l-2 9c-.4 1.2.4 2.1 1.7 2.1",
              fill: "#A6A8AB",
            },
          }),
        ]),
        _c(
          "g",
          {
            attrs: {
              fill: "#FAD08C",
              stroke: "#F6B140",
              "stroke-linejoin": "round",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "m252 94.2 14.4-2.5-5.5 32 23.4-40.6-14 2.4 2-38.8z",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }